import { cn } from '../lib/utils';

/* Inny, the dock bot: a compact warehouse droid with a visor, holding the
   carton it just received. The drawing lives in public/mascot*.svg so the
   same file serves the app icons and the in-app mark.
   animated: it bobs, the visor blinks, a scan line sweeps the carton, the
   beacon pulses (all off under prefers-reduced-motion, inside the SVG). */
export default function InnyMascot({ size = 40, animated = false, className, title = 'Inny' }) {
  return (
    <img
      src={animated ? '/mascot-animated.svg' : '/mascot.svg'}
      width={size}
      height={size}
      alt={title}
      draggable={false}
      className={cn('select-none', className)}
      style={{ width: size, height: size }}
    />
  );
}
